import clsx from "clsx"
import cn from "classnames"
import { SpinnerCircular } from "spinners-react"
import { ComponentPropsWithoutRef, FC, useMemo } from "react"
import { hapticFeedback } from "utils/hapticFeedback"
import { ButtonVip } from "./ui/button-vip"
import { ButtonBack } from "./ui/button-back"
import { ButtonInfo } from "./ui/button-info"
import { ButtonRing } from "./ui/button-ring"
import { ButtonWalletV1 } from "./ui/button-wallet-v1"
import { ButtonWalletV2 } from "./ui/button-wallet-v2"
import { ButtonUpgradeClanBuild } from "./ui/button-upgrade-clan-build"
import Container from "../container"
import "./style.scss"

export interface IButton extends ComponentPropsWithoutRef<"button"> {
  triangleBottomPosLeft?: string
  triangleTopPosLeft?: string
  isLoading?: boolean
  classNameContainer?: string
}

export const ButtonComponent: FC<IButton> = ({
  children,

  triangleBottomPosLeft,
  triangleTopPosLeft,
  isLoading = false,
  classNameContainer,

  className,
  onClick,
  ...rest
}) => {
  const isDisabled = useMemo(
    () => isLoading || rest.disabled,
    [isLoading, rest.disabled]
  )

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      hapticFeedback()
      onClick(e)
    }
  }

  return (
    <button
      {...rest}
      className={cn("custom-button", className)}
      disabled={isDisabled}
      onClick={handleClick}
    >
      <Container
        triangleTopPosLeft={
          triangleTopPosLeft === "none" ? undefined : triangleTopPosLeft
        }
        triangleBottomPosLeft={
          triangleBottomPosLeft === "none"
            ? undefined
            : triangleBottomPosLeft || "30%"
        }
        className={clsx("button-container", classNameContainer)}
      >
        {isLoading && (
          <SpinnerCircular
            className="loading-spinner"
            size={20}
            color="#35262699"
          />
        )}

        {isDisabled ? (
          <div className={clsx("children", { hidden: isLoading })}>
            {children}
          </div>
        ) : (
          children
        )}
      </Container>
    </button>
  )
}

export const Button = Object.assign(ButtonComponent, {
  Info: ButtonInfo,
  Back: ButtonBack,
  Ring: ButtonRing,
  UpgradeClanBuild: ButtonUpgradeClanBuild,
  Vip: ButtonVip,
  WalletV1: ButtonWalletV1,
  WalletV2: ButtonWalletV2
})
